// extracted by mini-css-extract-plugin
module.exports = {"head":"NavMenuSection_head__yZtB8","sending":"NavMenuSection_sending__2iwBB"};